// extracted by mini-css-extract-plugin
export var childrenContainer = "_40-0";
export var virtualScrollArea = "_40-1";